import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AuthorizationService } from "../services/application.service";
import { DatexErrorService } from "wavelength-ui";
import { firstValueFrom } from "rxjs";

export const canViewManagement: CanActivateFn =
  async () => {
    const authService = inject(AuthorizationService);
    const router = inject(Router);
    const datexErrorService = inject(DatexErrorService);

    const hasManagementAccess = await firstValueFrom(authService.hasManagementAccess());
    if (!hasManagementAccess) {
      const errorMesssage = `You are not authorized to access manager, please consult with your system admin.`;
      datexErrorService.add(new Error(errorMesssage));
      return router.createUrlTree(["/", "error"]);
    }

    return true;
  }
